import {
    OptionalChartInitialData,
    OptionalGroupedParsedChartData,
    ParsedChartSingleData,
    TrendsSingleParamData,
    WarningIndexSingleParamData
} from '../../types';

export type ChartParams = TrendsSingleParamData | Partial<WarningIndexSingleParamData>
export const mapToChartData = (data: ChartParams, params: string[]) => params.reduce((acc, el) => {
    if (data[el] && data.Timestamp) {
        Object.assign(acc, { [el]: { x: new Date(Number(data.Timestamp)), y: Number(data[el]) } });
    }
    return acc as OptionalGroupedParsedChartData;
}, {});

const parseDateToTimestampWithSeconds = (value: string) => (Date.parse(value) / 1000);

export type ParsedChartParams = OptionalGroupedParsedChartData | ParsedChartSingleData;
export const pushNewDataToCollectedData = (acc: OptionalGroupedParsedChartData, values: ParsedChartParams): OptionalGroupedParsedChartData => {
    if (acc) {
        Object.entries(values).forEach(([key, value]) => {
            const halfHour = 1800;
            const newestMsg = parseDateToTimestampWithSeconds(value.x);
            for (const propertiesName in acc) {
                if (acc[propertiesName].data.length) {
                    const oldestMsg = parseDateToTimestampWithSeconds(acc[propertiesName].data[0].x);
                    (newestMsg - oldestMsg >= halfHour) && acc[propertiesName].data.shift();
                }
            }
            acc[key].data.push(value);
        });
        return acc;
    }
    return values as OptionalGroupedParsedChartData;
};

export const parseToChartData = (data: OptionalChartInitialData) => {
    const parsedData = Object.entries(data).reduce((acc, [key, values]) => {
        const parsedValues = values.map(el => ({ x: new Date(Number(el.timestamp)), y: Number(el.value) }));
        const chartParam = { id: key, data: parsedValues };
        return Object.assign({}, acc, { [key]: chartParam });
    }, {} as OptionalGroupedParsedChartData)
    return parsedData;
};